<template>
  <base-modal ref="modal" @hiding="reset()" :overflowAuto="false">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin tw-mb-5">Batch Assign Activity</h3>
      <base-advanced-select label="Assign to" multiple :options="businessUsers" v-model="selectedUsers" placeholder="Select users" label-key="fullName" value-key="userId" />
      <inline-error id="assign-todo-error" class="tw-my-3" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="saveAssignment" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Assign</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "AssignTodoItem",
  components: { InlineError },
  props: {
    businessId: String,
    selectedItems: Array,
  },
  data() {
    return {
      businessUsers: [],
      allUsers: [],
      isLoading: false,
      selectedUsers: null,
      todoItemId: null,
      currentAssignedUserId: null,
      businessLocationId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
      allowedActivityTypes: ["Refill Authorization", "Prescriber Clarification"],
      localSelectedItems: [],
    };
  },
  computed: {
    ...mapGetters("cognito", { userId: "id" }),
  },
  created() {
    this.loadBusinessUsers();
  },
  methods: {
    show(selectedItems = []) {
      this.localSelectedItems = [...selectedItems]; // ✅ create a shallow copy

      if (!this.localSelectedItems.length) {
        this.errorTitle = "No items selected";
        this.errorMessage = "Please select at least one activity to assign.";
        this.error = true;
        return;
      }

      this.reset();
      this.filterBusinessUsers();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
      this.$emit("close");
    },
    reset() {
      this.selectedUsers = [];
      this.loadBusinessUsers();
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    loadBusinessUsers() {
      this.$axios.get(`/businesses/${this.businessId}/users/all`).then((res) => {
        this.allUsers = res.data;
        var index = this.allUsers.findIndex((x) => x.userId === this.userId);

        if (index > 0) this.allUsers[index].fullName = "(Me) " + this.allUsers[index].fullName;
      });
    },
    filterBusinessUsers() {
      var userOptions = [];

      //Add RxH users
      userOptions.push({
        businessId: null,
        email: null,
        hasPin: false,
        locations: [],
        roles: [],
        userId: null,
        fullName: "-- RxHarmony Users --",
        isHeader: true,
      });

      var rxhUsers = this.allUsers.filter((x) => x.locations.length === 0).sort((a, b) => (a.fullName > b.fullName ? 1 : b.fullName > a.fullName ? -1 : 0));
      for (var i = 0; i < rxhUsers.length; i++) {
        userOptions.push({
          businessId: rxhUsers[i].businessId,
          email: rxhUsers[i].email,
          fullName: rxhUsers[i].fullName,
          hasPin: rxhUsers[i].hasPin,
          locations: rxhUsers[i].locations,
          roles: rxhUsers[i].roles,
          userId: rxhUsers[i].userId,
          isHeader: false,
        });
      }

      this.businessUsers = userOptions;
    },
    async saveAssignment() {
      if (!this.selectedUsers.length) {
        this.errorTitle = "Select User Required";
        this.errorMessage = "Please select at least one user to assign the activity.";
        this.error = true;
        return;
      }

      if (!this.localSelectedItems.length) {
        this.errorTitle = "No Activities Selected";
        this.errorMessage = "Please select at least one activity to assign.";
        this.error = true;
        return;
      }

      this.isLoading = true;

      const payload = {
        assignedToUserIds: this.selectedUsers.map((user) => user.userId),
        todoItemIds: this.localSelectedItems,
      };

      try {
        await this.$axios.post(`/businesses/${this.businessId}/todo/batch-assign`, payload);

        this.EventBus.$emit("GLOBAL_NOTIFY", {
          title: "Activities Assigned",
          message: `Selected activities were assigned successfully.`,
        });

        this.EventBus.$emit("activitiesUpdated");
        this.hide();
      } catch (err) {
        this.errorTitle = "Error assigning activities";
        this.errorMessage = "There was an issue assigning the activities.";
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
